import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserState {
  userId: string
  name: string
  email: string
  picture: string
  lastLogin: string
  role: string
  isOnboarded: boolean
}

const initialState: UserState = {
  userId: '',
  name: '',
  email: '',
  picture: '',
  lastLogin: '',
  role: '',
  isOnboarded: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserInfo: (state, action: PayloadAction<Partial<UserState>>) => {
      const newState = { ...state, ...action.payload }
      return newState
    },

    clearUserInfo: () => {
      const emptyState = {
        userId: '',
        name: '',
        email: '',
        picture: '',
        lastLogin: '',
        role: '',
        isOnboarded: false,
      }

      return emptyState
    },
  },
})

export const { updateUserInfo, clearUserInfo } = userSlice.actions

export default userSlice.reducer
